var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RefreshButton flex item-center",on:{"click":_vm.refresh}},[_c('div',{staticClass:"icon-refresh"}),_c('div',[_vm._v(_vm._s(_vm.seconds))])])}
var staticRenderFns = []

export { render, staticRenderFns }